import { render, staticRenderFns } from "./post-card-category.vue?vue&type=template&id=7c24b1d0&scoped=true&"
import script from "./post-card-category.vue?vue&type=script&lang=js&"
export * from "./post-card-category.vue?vue&type=script&lang=js&"
import style0 from "./post-card-category.vue?vue&type=style&index=0&id=7c24b1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c24b1d0",
  null
  
)

export default component.exports